/* eslint-disable nordic/i18n-jsx-no-literals */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable consistent-return */
const React = require('react');
const Copy20 = require('@andes/icons/Copy20');
const Dropdown = require('@andes/dropdown');
const { Pill } = require('@andes/badge');
const ProgressIndicatorCircular = require('@andes/progress-indicator-circular');
const CopyToClipboard = require('react-copy-to-clipboard');
const { getEventTracker } = require('../../../../utils/event-tracker');
const Expand = require('./components/Images/expand');
const ModalSnippet = require('./components/ModalSnippet');
const LiveTestButton = require('./components/LiveTestButton');
const { useApiRefContextProvider } = require('../../../../providers/apiRefContextProvider');

const { useState, useEffect } = React;

const { DropdownForm, DropdownStandalone, DropdownItem } = Dropdown;

const Snippet = ({ i18n, codeContent, setApiSnackbar, setNewApiData, newApiData, codeLanguage, type, title, copyTrakingData, deviceType, lang, responseDataContent, apiData, siteId, setCodeType, setUpdateCodeContentRequestFromParams, updateCodeContentRequestFromParams }) => {
  const { apiRefLiveTestingEnabled } = useApiRefContextProvider();
  const Tracker = getEventTracker();
  const [showModal, setShowModal] = useState(false);
  const hasUserCases = apiData?.userCases?.length > 0;

  const createArray = function (values) {
    const linguagens = ['bash', 'java', 'php', 'js', 'ruby', 'csharp', 'python', 'json'];
    const resultado = ['bash'];

    linguagens.forEach(linguagem => {
      if (values[linguagem]) {
        resultado.push(linguagem);
      }
    });

    return resultado;
  };

  const createArrayForTitle = function (values) {
    const linguagens = [
      { title: 'cURL', value: 'bash' },
      { title: 'Java', value: 'java' },
      { title: 'PHP', value: 'php' },
      { title: 'NodeJS', value: 'js' },
      { title: 'Ruby', value: 'ruby' },
      { title: '.Net', value: 'csharp' },
      { title: 'Python', value: 'python' },
    ];
    const resultado = [{ title: 'cURL', value: 'bash' }];

    linguagens.forEach(linguagem => {
      if (values[linguagem.value]) {
        resultado.push({ title: linguagem.title, value: linguagem.value });
      }
    });

    return resultado;
  };

  const languages = apiData?.sdks ? createArray(apiData) : ['bash'];
  const languageOptions = apiData?.sdks ? createArrayForTitle(apiData)
    : [
      { title: 'cURL', value: 'bash' },
    ];

  const notCode = {
    description:
    {
      es: '// Esta solicitud no ha sido respondida.',
      pt: '// Esta requisição não tem resposta.',
      en: '// This request has not been responded to.',
    },
  };

  const copyAction = () => {
    navigator.clipboard.writeText(codeContent)
      .then(() => {
        setApiSnackbar(prev => ({
          ...prev,
          snackbarData: {
            show: true,
            message: i18n.gettext('Copiado con éxito.'),
            type: 'success',
            delay: 3000,
          },
        }));
      })
      .catch((e) => {
        console.log('Not Copied. Error: ', e);
      });

    if (copyTrakingData) {
      Tracker.send('mpdevelopers/api-ref/copy-snippet', {
        category: copyTrakingData.category,
        action: copyTrakingData.action,
        label: copyTrakingData.label,
      });
    }
  };

  useEffect(() => {
    if (showModal) {
      setTimeout(window.Prism.highlightAll, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const openModal = () => {
    setShowModal(true);
  };

  let countryIDCount = 0;

  apiData?.userCases?.forEach((uc) => {
    if (uc?.siteId?.map(s => s.toLowerCase())?.includes(siteId?.toLowerCase()) || uc?.siteId?.includes('allSites')) {
      countryIDCount += 1;
    }
  });

  const showDropDownUserCase = countryIDCount > 0;

  const dropdownItemsGenerate = (aData) => {
    const dropdownItems = [];
    aData?.userCases?.forEach((uc) => {
      if (aData?.userCases.indexOf(uc) === 0) {
        dropdownItems.push(<DropdownItem
          title={uc?.name?.[lang]}
          rightContent={<Pill size="small">{i18n.gettext('Más testeados')}</Pill>}
          value={uc?.name?.[lang]}
        />);
      } else if (uc.siteId?.map(s => s.toLowerCase()).includes(siteId?.toLowerCase()) || uc.siteId?.includes('allSites')) {
        dropdownItems.push(<DropdownItem
          title={uc?.name?.[lang]}
          value={uc?.name?.[lang]}
        />);
      }
    });
    return dropdownItems;
  };

  const updateExamples = (source, target, internalKey) => {
    if (source?.example === 'disabled') {
      return delete target.properties[internalKey];
    }
    if (source?.example) {
      target.properties[internalKey].example = source.example;
    }
  };

  const mapDataInArray = (propertyType, property, items) => {
    if (propertyType === 'array') {
      const itemsInProperty = property?.items?.properties || {};

      Object.entries(itemsInProperty).forEach(([itemKey, itemProperty]) => {
        updateExamples(itemProperty, items.items, itemKey);

        const nestedPropertiesInItems = itemProperty?.properties || {};
        if (nestedPropertiesInItems) {
          Object.entries(nestedPropertiesInItems).forEach(([nestedItemKey, nestedItemProperty]) => {
            updateExamples(nestedItemProperty, items.items.properties[itemKey], nestedItemKey);
          });
        }
      });
    }
  };

  const findMatchingResponses = (responseData) => {
    const responses = [200, 201, 204];
    const apiResponses = Object.getOwnPropertyNames(responseData);
    let matchingResponse;
    responses.forEach((res) => {
      if (apiResponses.includes(res.toLocaleString())) {
        matchingResponse = res; // Devuelve el primer elemento que coincida
      }
      return 'No found';
    });
    return matchingResponse;
  };

  function processProperties(property, apiProperty, parentProperty, propertyKey) {
    if (!property || !apiProperty) return;

    const internalProperties = property?.properties || {};

    updateExamples(property, parentProperty, propertyKey);
    mapDataInArray(apiProperty?.type, property, apiProperty);

    Object.entries(internalProperties).forEach(([internalKey, internalProperty]) => {
      const apiPropertiesInProperty = apiProperty.properties[internalKey];
      processProperties(internalProperty, apiPropertiesInProperty, apiProperty, internalKey);
    });
  }

  const mapData = (dataUserCase, apiResReqData, response) => {
    let apiResReq = apiResReqData;
    let userCaseResReq = dataUserCase;
    if (response === true) {
      const apiRes = findMatchingResponses(apiResReqData);
      const userCaseRes = findMatchingResponses(dataUserCase);
      apiResReq = apiResReqData[apiRes];
      userCaseResReq = dataUserCase[userCaseRes];
    }

    const userCaseProperties = Object.getOwnPropertyNames(userCaseResReq.content['application/json'].schema.properties);

    userCaseProperties.forEach((propertyKey) => {
      const property = userCaseResReq.content['application/json'].schema.properties[propertyKey];
      const apiProperty = apiResReq.content['application/json'].schema.properties[propertyKey];

      processProperties(property, apiProperty, apiResReq.content['application/json'].schema, propertyKey);
    });

    return apiResReqData;
  };

  const mapUserCases = (aData, nData) => {
    const aDataReqBody = JSON.parse(JSON.stringify(aData?.requestBody));
    const nDataReqBody = nData?.requestBody;

    const aDataResponses = JSON.parse(JSON.stringify(aData?.responses));
    const nDataResponses = nData?.responses;

    const nDataParameters = nData?.parameters;

    const tData = JSON.parse(JSON.stringify(aData));

    if (nDataParameters) {
      const aDataParameters = JSON.parse(JSON.stringify(aData?.parameters));
      const nDataParametersNames = nDataParameters.map((pn) => { return pn.name; });
      nDataParametersNames.forEach((p) => {
        aDataParameters.forEach((ap) => {
          if (ap.name === p) {
            if (nDataParameters[nDataParametersNames.indexOf(p)].schema.example === 'disabled') {
              return delete aDataParameters[aDataParameters.indexOf(ap)].schema;
            }
            aDataParameters[aDataParameters.indexOf(ap)].schema.example = nDataParameters[nDataParametersNames.indexOf(p)].schema.example;
          }
        });
      });
      tData.parameters = aDataParameters;
    }

    if (nDataReqBody) {
      tData.requestBody = mapData(nDataReqBody, aDataReqBody, false);
    }
    if (nDataResponses) {
      tData.responses = mapData(nDataResponses, aDataResponses, true);
    }

    setNewApiData(tData);
  };


  useEffect(() => {
    window.Prism.highlightAll();
  }, [apiData, newApiData, codeLanguage]);

  const [showUseCases, setShowUseCases] = useState(false);

  useEffect(() => {
    setShowUseCases(apiData && hasUserCases);
  }, [apiData, hasUserCases, showUseCases]);

  const renderCodePre = (typeName, language, code, languageCode) => {
    return (
      <pre className={`code-container--${typeName} api-ref-scrool language-${language} line-numbers`} style={{ display: languageCode !== language ? 'none' : 'block' }}>
        <code>
          {code}
        </code>
      </pre>
    );
  };
  const titleDropdownUseCase = i18n.gettext('Solicitud personalizada');

  const [userCaseName, setUserCaseName] = useState(apiData?.userCases ? apiData?.userCases[0]?.name[lang] : i18n.gettext('Selecciona una opción'));

  useEffect(() => {
    if (updateCodeContentRequestFromParams) {
      setUserCaseName(titleDropdownUseCase);
    }
  }, [updateCodeContentRequestFromParams]);

  return (
    <>
      <div className={`snippet snippet--${type}`}>
        <div className="snippet--header">
          <span className="title">{title}</span>
          <div className="actions">
            {type === 'request' && !hasUserCases && (
              <div className="api-dropdown-language">
                <DropdownStandalone
                  defaultOpen={false}
                  defaultValue="bash"
                  onChange={(event, value) => { setCodeType(value); }}
                  menuAlignment="bottom"
                  menuMaxHeight={500}
                  value={codeLanguage}
                  id="dropdown-id"
                  label=""
                  srLabel=""
                >
                  {languageOptions.map(option => (
                    <DropdownItem
                      title={option.title}
                      value={option.value}
                    />
                  ))}
                </DropdownStandalone>
              </div>
            )}

            <div className="api-expand">
              <Expand openModal={openModal} />
            </div>
            <div>
              <CopyToClipboard
                onCopy={() => {
                  copyAction();
                }}
              >
                <div className="api-copy">
                  <Copy20 color="rgba(0, 0, 0, 0.55)" />
                </div>
              </CopyToClipboard>
            </div>

          </div>
        </div>
        {showUseCases && showDropDownUserCase && (
          <div className="api-dropdown-usercases">
            <DropdownForm
              id="dropdown-id"
              placeholder={userCaseName}
              className="api-dropdown-usercases-form"
              srLabel={i18n.gettext('Solicitud personalizada')}
              menuAlignment="bottom"
              type="form"
              value={userCaseName}
              onChange={(e) => {
                setUserCaseName(e.target.value);
                const index = apiData?.userCases?.findIndex((uc) => { return uc?.name?.[lang] === e.target.value; });
                if (index !== -1) {
                  mapUserCases(apiData, apiData?.userCases?.[index]);
                  setUpdateCodeContentRequestFromParams(false);
                } else {
                  setNewApiData(apiData);
                }
              }}
            >
              {dropdownItemsGenerate(apiData)}

            </DropdownForm>
          </div>)}
        <div className={`code_editor--${type}`} language={codeLanguage}>
          {
            codeContent !== '{}' ? (
              <>
                {type === 'request' ? (
                  <>
                    {languages.map(language => (
                      renderCodePre(type, language, codeContent, codeLanguage)
                    ))}
                  </>
                ) : (
                  <pre className={`code-container--${type} api-ref-scrool language-${codeLanguage} line-numbers`}>
                    <code>
                      {codeContent}
                    </code>
                  </pre>
                )}
              </>
            ) : (
              <>
                {
                  responseDataContent?.status === 'loading' ? (
                    <div className="loading">
                      <ProgressIndicatorCircular size="large" className="spinner_test" />
                    </div>
                  )
                    : (
                      <div className="not-code">
                        {notCode?.description?.[lang]}
                      </div>
                    )
                }
              </>
            )
          }

        </div>
        {(type === 'request' && apiRefLiveTestingEnabled) && (
          <LiveTestButton i18n={i18n} />
        )}
      </div>

      <ModalSnippet
        showModal={showModal}
        codeContent={codeContent}
        codeLanguage={codeLanguage}
        languageOptions={languageOptions}
        type={type}
        title={title}
        setShowModal={setShowModal}
        copyAction={copyAction}
        deviceType={deviceType}
        notCode={notCode}
        lang={lang}
        setCodeType={setCodeType}
      />
    </>
  );
};

module.exports = Snippet;

